import { render } from "./vSection.vue?vue&type=template&id=06f04eb4&scoped=true"
import script from "./vSection.vue?vue&type=script&lang=js"
export * from "./vSection.vue?vue&type=script&lang=js"

import "./vSection.vue?vue&type=style&index=0&id=06f04eb4&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\danil\\PersonalData\\WebsiteDevelopment\\GitHub\\biorobot-factory\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06f04eb4"]])

export default __exports__